export default "__VITE_ASSET__c793691a__"